import { listenerMiddleware } from '../middleware.js';
import { setSelectedConversationId, RECIEVE_MESSAGE, RECEIVED_ROOM_MESSAGE, setChatPartner, MESSAGE_SUCCESS, SEND_CONVERSATION_READ, MESSAGE_READ_UPDATE } from './messagesSlice.js';
import { getConversationPreviews, getUnreadMessagesByConversation,mirrorDmToMattermost } from './messagesThunks.js';


listenerMiddleware.startListening({
  actionCreator: setSelectedConversationId,
  effect: async (action, api) => {
    const id = action?.payload;

    await api.dispatch(getUnreadMessagesByConversation());
    await api.dispatch(getConversationPreviews({ source: "afterRead" }));
  },
});


listenerMiddleware.startListening({
  actionCreator: RECIEVE_MESSAGE,
  effect: async (action, api) => {
    const state = api.getState();
    const msg = action?.payload?.data ?? action?.payload;

    if (!msg) return;

    const { controlPanel, messageHistory, auth } = state;
    const isOpen = controlPanel.openModal === "message_history";
    const selectedId = messageHistory.selectedConversationId;
    const localEmail = auth?.localAvatar?.email;
    await api.dispatch(getUnreadMessagesByConversation());
    if (!isOpen) {
      await api.dispatch(getConversationPreviews());
      return;
    }

    if (msg.conversation_id === selectedId) {
      const recipientEmail = msg?.recipient?.email;
      const isRecipient =
        recipientEmail &&
        localEmail &&
        recipientEmail.toLowerCase() === localEmail.toLowerCase();

      if (isRecipient && localEmail) {
        api.dispatch(
          SEND_CONVERSATION_READ({
            conversationId: selectedId,
            readerEmail: localEmail,
          })
        );
      }

    } else {
      await api.dispatch(getConversationPreviews());
    }
  },
});

listenerMiddleware.startListening({
  actionCreator: RECEIVED_ROOM_MESSAGE,
  effect: async (action, api) => {
    const state = api.getState();
    const msg = action?.payload?.data ?? action?.payload;
    await api.dispatch(getUnreadMessagesByConversation());
    if (state.controlPanel.openModal === 'message_history' && msg) {
      if (msg.conversation_id === state.messageHistory.selectedConversationId) {
        await api.dispatch(getConversationPreviews({ source: 'afterRead' }));
      } else {
        await api.dispatch(getConversationPreviews());
      }
    }
  },
});

listenerMiddleware.startListening({
  actionCreator: MESSAGE_SUCCESS,
  effect: async (action, api) => {
    const state = api.getState();
    const data = action.payload?.data ?? action.payload;
    const msg = data?.fullMessage;
    if (!msg) return;

    const tenantId = api.getState().auth?.tenant?.id;
    if (!tenantId) {
      console.warn("[MM] tenantId missing in state.auth.tenant.id");
      return;
    }

    await api.dispatch(
      mirrorDmToMattermost({
        params: [{ tenantId }],
        body: {
          recipientEmail: msg.recipient.email,
          message: msg.text ?? msg.message ?? msg.content ?? "",
        }
      })
    ).unwrap();

    const convId = msg.conversation_id;
    if (state.controlPanel.openModal === "message_history") {
      if (state.messageHistory.selectedConversationId === convId) {
        await api.dispatch(
          getConversationPreviews({ source: "afterRead" })
        );
      } else {
        await api.dispatch(getConversationPreviews());
      }
    }
  }
});

listenerMiddleware.startListening({
  actionCreator: MESSAGE_READ_UPDATE,
  effect: async (action, api) => {
    const conversationId =
      action.payload?.conversationId ??
      action.payload?.data?.conversationId;

    const readerEmail =
      action.payload?.readerEmail ??
      action.payload?.data?.readerEmail;

    if (!conversationId) {
      console.warn("MESSAGE_READ_UPDATE triggered but no conversationId found in payload:", action.payload);
      return;
    }
    await api.dispatch(getUnreadMessagesByConversation());
    await api.dispatch(getConversationPreviews({ source: "afterRead" }));

  }
});
